import React, { Component } from 'react';
import { currency } from './../../../helpers';

class ItemBundles extends Component {

	products(){
		return this.props.item.products.map(( product, i ) => (
			<div key={ (+new Date()) + i }>
				<div >
					<p className="p-tag brand-color bundle-description-title">{ product.name }</p>
				</div>
				<hr className="hr-divider"/>
			</div>
		));
	}

	addToBasketBtn(){
		return (
			<button type="button" className={ `btn btn-primary membership-btn ${ this.props.index === 3 ? 'super-premium' : '' }` } onClick={ this.props.onAddToCartClicked }>
				Add To Basket
			</button>
		);
	}

	render() {

		let price = null;
		let currencySign = '&#163;';

		if( this.props.item.price ){
			price = currency.convert( this.props.item.price.value );
			currencySign = price.substring( 0, 1 );
		};

		return (
			<div className="col-xs-12 col-sm-6 col-lg-3 margin-bottom">
				<div className={ `display-box text-center padding-xy border ${ this.props.index === 3 ? 'super-premium' : '' }` }>
					<div>
						<h3 className={ `brand-color ${ this.props.index === 3 ? 'recommended' : '' }` }>{ this.props.item.name }</h3>
					</div>
					<div className="margin-bottom">
						<div className="brand-color margin-none bundle-price currency-bundle">{ currencySign }</div>
						<div className="margin-none bundle-price">{ price }</div>
					</div>
					{ this.products.call(this) }
					{ !this.props.purchased ? this.addToBasketBtn.call( this ) : 'In Basket' }
				</div>
			</div>
		);
	};
}

export default ItemBundles;



// WEBPACK FOOTER //
// src/client/components/common/transactions/ItemBundles.js